import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <g filter="url(#filter0_f_301_27354)" opacity="0.1">
      <path
        d="M24 71.6992C30.6274 71.6992 36 69.9084 36 67.6992C36 65.4901 30.6274 63.6992 24 63.6992C17.3726 63.6992 12 65.4901 12 67.6992C12 69.9084 17.3726 71.6992 24 71.6992Z"
        fill="black"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M25.5 47.9539C38.0561 47.1796 48 36.7511 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 36.7511 9.9439 47.1796 22.5 47.9539V66.5C22.5 67.3284 23.1716 68 24 68C24.8284 68 25.5 67.3284 25.5 66.5V47.9539Z"
      fill="#FA6A3C"
      fillRule="evenodd"
    />
    <path
      d="M24 17C20.136 17 17 20.136 17 24C17 27.864 20.136 31 24 31C27.864 31 31 27.864 31 24C31 20.136 27.864 17 24 17Z"
      fill="white"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="13.4366"
        id="filter0_f_301_27354"
        width="29.4366"
        x="9.28172"
        y="60.9809"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_301_27354" stdDeviation="1.35914" />
      </filter>
    </defs>
  </>,
  'Pin',
)
